import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { EMPTY, catchError } from "rxjs";
import { OrganizersService } from "../app/services/organizers.service";
import { Organizer } from "../app/services/types/organizer.type";

export const organizerResolver: ResolveFn<Organizer> = (route) => {
  const router = inject(Router);
  const organizersService = inject(OrganizersService);

  const organizerPage = route.paramMap.get("organizer_page");

  if (!organizerPage) {
    router.navigateByUrl("/page-not-found");
    return EMPTY;
  }

  return organizersService.getOrganizer(organizerPage).pipe(
    catchError(() => {
      router.navigateByUrl("/page-not-found");
      return EMPTY;
    }),
  );
};
